export default {
  isDirectionListLoading: false,
  isDirectionListError: false,
  directionListResult: false,
  directionListErrorMessage: false,
  directionList: []
};
